import React from "react";
import {
  t,
  MH_TITLE1,
  MH_TITLE2,
  MH_TITLE3,
  MH_TITLE4,
  MI_FAQ,
  MI_SITEMAP,
  MI_USER_MANUAL,
  MI_CONTACT_US,
  MI_TIME_TABLE,
  MI_BOOK_BUS,
  MI_FR_LOGIN,
} from "../../translations/Footer/Footer";

import {
  tFooterCommon,
  ABOUT_US,
  HISTORY,
  MI_BUS_SERVICES,
  MI_KEY_STATISTICS,
  MI_LABOUR_WELFARE,
  MI_PROCUREMENT,
  MI_PASSENGER_SAFETY,
  MI_INFRA_FACILITY,
  MI_ANNUAL_REPORT,
  MI_LETTER_CIRCULARS,
  MI_LUGGAGE_RATES,
  MI_RES_TERMS,
  MI_GUEST_USER_TERMS,
  MI_REFUND_RULES,
  MI_BOOKING_COUNTERS,
  MI_PASSESS_CONCESSION,
  MI_NEWS_EVENTS,
  MI_TENDER,
  MI_RECRUITMENT,
  MI_CAREERS,
  MI_SENIORITY_LIST,
  MI_KSRTC_FRANCHISEE,
} from "../../translations/Footer/Common";
import { FOOTER_COMP_INFO, tCommon } from "../../translations/Common";
import { getImgPath } from "../common/helper";


const Footer = () => {
  return (
    <div className="reveal">
      <div className="footer--top--wrapper">
        <div className="footer--top--block">
          <h1>{t(MH_TITLE1)}</h1>
          <ul>
            <li>
              <a href="https://awatar4.ksrtc.in/">{t(MI_FR_LOGIN)}</a>
            </li>
            <li>
              <a href="/reservation_terms">{tFooterCommon(MI_RES_TERMS)}</a>
            </li>
            <li>
              <a href="/guest_users_terms">{tFooterCommon(MI_GUEST_USER_TERMS)}</a>
            </li>
            <li>
              <a href="/refund_rules_and_claims">{tFooterCommon(MI_REFUND_RULES)}</a>
            </li>
            <li>
              <a
                href="https://ksrtc.karnataka.gov.in/storage/pdf-files/FAQs/FAQs.pdf"
                target="_blank"
              >
                {t(MI_FAQ)}
              </a>
            </li>
            
           {/*  <li>
              <a href="/new-franchisee-procedure">
                {" "}
                {tFooterCommon(MI_KSRTC_FRANCHISEE)}
              </a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-2/Time+Table/en"> {t(MI_TIME_TABLE)}</a>
            </li> */}
            
          </ul>
        </div>
        <div className="footer--top--block">
          <h1>&nbsp;{/* tFooterCommon(ABOUT_US) */}</h1>
          <ul>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-2/Casual+Contract+(Hire+a+Bus)/en">{t(MI_BOOK_BUS)}</a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-2/Luggage+transportation+and+charges/en">{tFooterCommon(MI_LUGGAGE_RATES)}</a>
            </li>
            <li>
              <a href="/booking_counters">{tFooterCommon(MI_BOOKING_COUNTERS)}</a>
            </li>
            <li>
              <a href="/sitemap.xml" target="_blank">
                {t(MI_SITEMAP)}
              </a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/page/Contact+Us/en">
                {t(MI_CONTACT_US)}
              </a>
            </li>
            {/* 
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-1/About++KSRTC/en">{tFooterCommon(ABOUT_US)}</a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-1/About++KSRTC/en">{tFooterCommon(HISTORY)}</a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-2/Bus+Services/en">{tFooterCommon(MI_BUS_SERVICES)}</a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-1/Key+Statistics/en">{tFooterCommon(MI_KEY_STATISTICS)}</a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-1/Labour+Welfare/en"> {tFooterCommon(MI_LABOUR_WELFARE)}</a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-1/Infrastructure+&+Facility/en">
                {" "}
                {tFooterCommon(MI_INFRA_FACILITY)}
              </a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-1/KSRTC+Procurement+Procedure+&+Statistics/en">{tFooterCommon(MI_PROCUREMENT)}</a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-4/Annual+Administrative+Report/en">
                {tFooterCommon(MI_ANNUAL_REPORT)}
              </a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-1/Passenger+Safety/en">{tFooterCommon(MI_PASSENGER_SAFETY)}</a>
            </li>*/}
          </ul>
        </div>
        {/*
        <div className="footer--top--block">
          <h1>{t(MH_TITLE3)}</h1>
          <ul>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-4/Letters+and+Circulars/en">
                {tFooterCommon(MI_LETTER_CIRCULARS)}
              </a>
            </li>
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-2/Passes+&+Concession/en">
                {" "}
                {tFooterCommon(MI_PASSESS_CONCESSION)}
              </a>
            </li>
          </ul>
        </div>
        <div className="footer--top--block">
          <h1>{t(MH_TITLE4)}</h1>
          <ul>
            <li>
              <a
                href="https://ksrtc.karnataka.gov.in/info-4/News+and+Events/en"
                target="_blank"
              >
                {tFooterCommon(MI_NEWS_EVENTS)}
              </a>
            </li>
            <li>
              <a
                href="https://ksrtc.karnataka.gov.in/info-4/Tenders/en"
                target="_blank"
              >
                {tFooterCommon(MI_TENDER)}
              </a>
            </li>
            <li>
              <a href="https://ksrtcjobs.karnataka.gov.in/" target="_blank">
                {tFooterCommon(MI_RECRUITMENT)}
              </a>
            </li>
            {/* <li>
              <a href="https://www.ksrtcjobs.com/" target="_blank">
                {tFooterCommon(MI_CAREERS)}
              </a>
            </li> *
            <li>
              <a href="https://ksrtc.karnataka.gov.in/info-4/Seniority+List/en" target="_blank">
                {tFooterCommon(MI_SENIORITY_LIST)}
              </a>
            </li>
            *<li>
                          <a
                            href="https://www.ksrtc.in/web-content/pdf/KSRTC_Web_Bkg_Flow.pdf"
                            target="_blank"
                          >
                            {t(MI_USER_MANUAL)}
                          </a>
                        </li>*}
          </ul>
        </div>*/}
        <div class="footer--top--block">
            <h1>&nbsp;</h1> 
            <ul>
                <li class="litxt">This site provides information related to reservation services only.</li>
                <li class="litxt">For complete details, additional resources, and the latest updates,<br/> please visit our main website:</li>
                <li class="litxt link">
                    <img src={getImgPath("/img/right-hand.svg")} alt="right-hand" width="19" height="19" />
                    <a href="http://ksrtc.karnataka.gov.in" target="_blank">ksrtc.karnataka.gov.in</a>
                </li>
            </ul> 
        </div>
      </div>
      <div className="footer--copy--wrapper">
        ©{window.currentYear} {tCommon(FOOTER_COMP_INFO)}
      </div>
    </div>
  );
};

export default Footer;
